<template>
  <div id="tablePage">
    <!-- 持仓明细 -->
    <div class="orderTable">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        :cell-class-name="directionClass"
        @sort-change="sortChange"
        v-loading="loading"
      >
        <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <!-- <el-table-column type="index" width="100">
          <template slot-scope="scope">
            <span class="spotS" @click.stop="openSpotDialog(scope.row)"> 止盈止损</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="holdDetailId" label="持仓单号" width="80">
        </el-table-column>
        <el-table-column
          prop="commodityCode"
          label="商品代码"
        >
        </el-table-column>
        <el-table-column
          prop="commodityName"
          label="商品名称"
        >
        </el-table-column>
        <el-table-column
          prop="bsFlag"
          label="买|卖"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="initPrice"
          label="订立价格"
          sortable
        >
          <template slot-scope="scope">
            <span
              :class="
                scope.row.bsFlag == '买入' ? 'red-row' : 'green-row'
              "
            >
              {{ Number(scope.row.initPrice).toFixed(scope.row.priceScale) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="APP_WINNY_NAME !== '楚云农商'"
          prop="stopProfitPrice"
          label="止盈价"
          sortable
        >
          <template slot-scope="scope">
            <span
              :class="
                scope.row.bsFlag == '买入' ? 'red-row' : 'green-row'
              "
            >{{ Number(scope.row.stopProfitPrice).toFixed(scope.row.priceScale) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="APP_WINNY_NAME !== '楚云农商'"
          prop="stopLossPrice"
          label="止损价"
          sortable
        >
          <template slot-scope="scope">
            <span
              :class="
                scope.row.bsFlag == '买入' ? 'red-row' : 'green-row'
              "
            >{{ Number(scope.row.stopLossPrice).toFixed(scope.row.priceScale) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="initQuantity"
          label="订立数量"
          sortable
        >
          <template slot-scope="scope">
            <span> {{ scope.row.initQuantity }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="quantity"
          label="存货数量"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.quantity }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="frozeQuantity"
          label="冻结数量"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.frozeQuantity }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="ddQuantity"
          label="抵顶数量"
          min-width="100"
        >
          <template slot-scope="scope">
            <span class="yellow-row fr"> {{ scope.row.ddQuantity }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="holdMargin"
          label="存货订金"
          sortable
        >
          <template slot-scope="scope">
            <span> {{ scope.row.holdMargin }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="holdPl"
          label="货值变化"
          sortable
          min-width="110"
        >
          <template slot-scope="scope">
            <span
              :class="
                scope.row.textColor
              "
            >
              {{ Number(scope.row.holdPl).toFixed(scope.row.priceScale) }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="createTime" label="订立时间" width="90">
        </el-table-column>
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <!-- <buy-hold ref="buyHold" @reLoad="searchData" /> -->
  </div>
</template>
<script>
/*global http protocol util*/
import { mapGetters } from 'vuex'
// import buyHold from '../../transcc/new/buyHold'
export default {
  components: {
    // buyHold
  },
  data() {
    return {
      tableHeight: 0,
      loading: false,
      isSpotS: false,
      tableData: [],
      currentBtn: 1, // 0全部 1当日 2历史
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      timer: null,
      oOrderPrice: '',
      thsTableWidth: {
        action: 142
      },
      dataArr: '',
      isNetWrong: false,
      ttpTableWidth: {
        openTime: 180,
        currencyName: 110,
        direction: 80
      },
      HoldDetailListSum: {
        availableQuantity: null,
        bsFlag: null,
        commodityCode: null,
        commodityId: null,
        commodityName: null,
        createTime: null,
        dqTime: null,
        firmId: null,
        frozeQuantity: 0,
        holdDay: null,
        holdDetailId: null,
        margin: 0,
        pickupStartTime: null,
        quantity: 0,
        remainDay: null, // 剩余天数
        singlePrice: null,
        tradeDay: null,
        tradeId: null,
        tradeSinglePrice: null,
        tradeTime: null,
        unitNumeral: null,
        updateTime: null,
        sumClosePl: 0
      },
      APP_WINNY_NAME: window.g.APP_WINNY_NAME
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'commodityStrategyGetter', 'marketDetails'])
  },
  watch: {

  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  mounted() {
    this.showData()
    // this.timer = setInterval(() => {
    //   this.showData()
    // }, window.g.APP_RUNLOOP_TIME ? window.g.APP_RUNLOOP_TIME : 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    // 点击止盈止损
    openSpotDialog(obj) {
      this.$refs.buyHold.showDialog(obj)
    },
    reload() {
      this.recursionShowData()
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      this.loading = true
      protocol.queryUserHoldingsSubsidiariesNew.data.page =
          this.pageData.currentPage - 1
      protocol.queryUserHoldingsSubsidiariesNew.data.size =
          '' + this.pageData.pageSize
      // protocol.queryUserHoldingsSubsidiariesNew.data.firmId = this.sessionInfoGetter.firmId
      protocol.queryUserHoldingsSubsidiariesNew.data.bsFlag = null
      protocol.queryUserHoldingsSubsidiariesNew.data.commodityId = null
      http.gPost(protocol.queryUserHoldingsSubsidiariesNew).then(response => {
        if (response.data.code != 0) {
          this.isNetWrong = true
          this.$message({ message: response.data.message })
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.dataArr = JSON.stringify(response.data.value.content)
            this.judgeDataType(arr)
            this.HoldDetailListSum = response.data.value.sumData
          }
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
        setTimeout(() => {
          that.showData()
        }, 1000)
      })
    },
    threeTxtColor(price) {
      // 商品价格大于0红色，小于0绿色，等于0灰色
      if (!isNaN(price)) {
        if (price > 0) {
          return 'red-row'
        } else if (price < 0) {
          return 'green-row'
        } else {
          return ''
        }
      }
      return ''
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        arrIndex.floatPL = 0
        arrIndex.textColor = ''
        arrIndex.textColor = that.threeTxtColor(Number(arrIndex.holdPl))
        const currentTime = arrIndex.pickupStartTime * 24 * 60 * 60 * 1000
        const timer = util.floatAdd(arrIndex.createTime, currentTime)
        // arrIndex.unterQuantity = util.floatSub(arrIndex.quantity, arrIndex.frozeQuantity)
        arrIndex.pickupStartTime = util.dateDayFormate(Number(timer))
        // 判断时间
        that.modifyTime(arrIndex, 'createTime')
        that.modifyTime(arrIndex, 'tradeTime')
        // that.modifyTime(arrIndex, 'tradeTime')
        // that.modifyTime(arrIndex, 'pickupStartTime')
        // 判断方向
        that.modifyData(arrIndex, 'bsFlag', 'B', '买入', '卖出')
        // 判断委托状态 1-已委托，2-已成交，3-已撤单，4-部分成交，5-部分成交后撤单
        const stateList = ['已委托', '已成交', '已撤单', '部分成交', '部分成交后撤单']
        stateList.forEach((item, index) => {
          that.modifyData(arrIndex, 'orderStatus', index + 1, item)
        })
      })
      this.tableData = arr
    },
    // 排序
    sortChange(column, prop, order) {
      if (column.order == 'ascending') {
        protocol.queryUserHoldingsSubsidiariesNew.data.sort[0].direction = 'ASC'
        this.eachSortChange(column.column.property)
      } else if (column.order == 'descending') {
        protocol.queryUserHoldingsSubsidiariesNew.data.sort[0].direction = 'DESC'
        this.eachSortChange(column.column.property)
      } else {
        protocol.queryUserHoldingsSubsidiariesNew.data.sort = [{
          direction: 'DESC',
          property: 'holdDetailId'
        }]
      }
      protocol.queryUserHoldingsSubsidiariesNew.data.firmId = this.sessionInfoGetter.firmId
      protocol.queryUserHoldingsSubsidiariesNew.data.commodityId = null
      if (column.column) {
        http.gPost(protocol.queryUserHoldingsSubsidiariesNew).then(response => {
          if (response.data.code != 0) {
            this.isNetWrong = true
            this.$message({ message: response.data.message })
          } else {
            this.isNetWrong = false
          }
          if (response.data) {
            if (response.data && response.data.code == '0') {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.HoldDetailListSum = response.data.value.sumData
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      return (protocol.queryUserHoldingsSubsidiariesNew.data.sort[0].property = str)
    },
    // 递归订单展示
    recursionShowData() {
      this.showData()
    },
    // 合计
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const that = this
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 8) { // 持仓数量
          sums[index] = that.HoldDetailListSum.quantity
          return
        }
        if (index === 9) { // 存货数量
          sums[index] = that.HoldDetailListSum.quantity
          return
        }
        if (index === 10) { // 抵顶数量
          sums[index] = that.HoldDetailListSum.ddQuantity
          return
        }
        if (index === 11) { // 存货订金
          sums[index] = that.HoldDetailListSum.margin
          return
        }

        sums[index] = ''
      })
      return sums
    },
    // 单元格颜色
    directionClass(row, column, rowIndex, columnIndex) {
      // 根据字段改变样式
      if (row.columnIndex == 3) {
        return this.setStrClass(row.row.bsFlag, '卖出', 'dropColor', 'increaseColor')
      }
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale = localStorage.lang || navigator.language.slice(-2).toLowerCase()
      switch (localStorage.lang) {
        case 'en': {
          const tcdTableEnWidth = {
            bsFlag: 120,
            ocFlag: 150,
            closePl: 150
          }
          localStorage.setItem('tcdTableEnWidth', JSON.stringify(tcdTableEnWidth))
          this.tcdTableWidth = JSON.parse(localStorage.tcdTableEnWidth)
        }
          break
        default:
          break
      }
    }

  }

}
</script>
<style lang="scss" scoped>
</style>
<style>
#fourTabPage .el-table--border::after,#fourTabPage .el-table--group::after, .el-table::before{
  background-color:transparent;
}
#fourTabPage .el-table td,#fourTabPage .el-table th.is-leaf{
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
#fourTabPage .el-table--border,#fourTabPage .el-table--group{
  border:none;
}
#fourTabPage .el-table td div{
  text-align:center;
  font-family: Source Han Sans SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
#fourTabPage .el-table--border td, #fourTabPage .el-table--border th,#fourTabPage .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid rgba(0, 0, 0, 0.1);
}
#fourTabPage .el-pagination button:disabled,
#fourTabPage .el-pagination .btn-prev,
#fourTabPage .el-pagination .btn-next,
#fourTabPage .el-pager li,
#fourTabPage .el-pagination__editor.el-input .el-input__inner,
#fourTabPage .el-pagination .el-select .el-input .el-input__inner,
#fourTabPage .el-table table tr,
#fourTabPage .el-table th,
#fourTabPage .el-table,
#fourTabPage .el-table__footer-wrapper tbody td,
#fourTabPage .el-table__header-wrapper tbody td {
  background: #ffffff;
}
#fourTabPage .el-table td,#fourTabPage .el-table th{
    padding:2px 0;
}
#fourTabPage .el-table__footer-wrapper td{
    border-top:none;
}
#fourTabPage .el-table--striped .el-table__body tr.el-table__row--striped.current-row td,
#fourTabPage .el-table__body tr.current-row > td,
#fourTabPage .el-table__body tr.hover-row.current-row > td,
#fourTabPage .el-table__body tr.hover-row.el-table__row--striped.current-row > td,
#fourTabPage .el-table__body tr.hover-row.el-table__row--striped > td,
#fourTabPage .el-table__body tr.hover-row > td,
#fourTabPage  .el-table th.el-table__cell {
  background: #ffffff;
}
#fourTabPage .el-table__header-wrapper th > .cell{
  font-family: Source Han Sans SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  text-align:center;
  line-height: 34px
}
#fourTabPage .el-table .el-table__cell{
  padding:4px 0;
}
#fourTabPage .el-table td.el-table__cell,#fourTabPage .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
#fourTabPage .el-table__footer-wrapper td:nth-child(10) .cell {
  color: #cee600;
}
#fourTabPage .el-table__footer{
 border-top: 1px solid rgba(0, 0, 0, 0.1);
}

</style>
